import styled, { css } from 'styled-components';

export const Form = styled.form`
  margin: 0;
  padding: 0;
`;

export const DuoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr fit-content(100%);
  row-gap: 16px;
  column-gap: 16px;
  align-items: stretch;
  grid-auto-columns: 1fr;
  grid-column: span 2;

  @media only screen and (max-width: 500px) {
    grid-template-columns: 1fr;
    grid-column: unset;
  }
`;

export const MapContainer = styled.div`
  border-radius: 20px;
  border: 1px solid #eae7e7;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  background-color: #fff;
  width: 100%;
  grid-column: span 2;
  margin-top: 4px;
  overflow: hidden;

  @media only screen and (max-width: 500px) {
    grid-column: unset;
  }
`;

export const PinMapFloat = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 18px 18px 5.4px 18px;
  background: #fff;
  border: 2px solid #2a6346;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
  position: absolute;
  z-index: 999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  transform: rotate(45deg);
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    transform: rotate(-45deg);
    color: #2a6346;
    font-size: 18px;
  }
`;

interface IMapFloatProps {
  showOnlySmallScreen?: boolean;
}

export const MapFloat = styled.div<IMapFloatProps>`
  border-radius: 10px;
  padding: 16px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  height: min-content;

  @media only screen and (min-width: 500px) {
    ${(props) => (props.showOnlySmallScreen ? 'display: none;' : '')}
  }
`;

export const TitleFloat = styled.label`
  color: #6e6e6e;
  font-family: Roboto;
  font-weight: bold;
  font-size: 14px;
`;

interface ITextFloatProps {
  useGrayColor?: boolean;
  marginTop?: string;
}

export const TextFloat = styled.label<ITextFloatProps>`
  margin-top: ${({ marginTop = '5px' }) => marginTop};
  color: ${({ useGrayColor }) => (useGrayColor ? '#aaaaaa' : '#6e6e6e')};
  font-family: Roboto;
  font-weight: normal;
  font-size: 12px;
  word-break: break-all;

  & b {
    color: #6e6e6e;
  }
`;

export const LineSpacer = styled.div`
  width: 100%;
  height: 2px;
  background-color: #eae7e7;
  margin: 30px 0;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;

  /* barra de input */
  & > div:first-of-type {
    flex: 1;
  }

  /* btn de usar posicao */
  & > div:nth-child(2) > button {
    width: 190px;
  }

  /* btn de buscar */
  & > div:nth-child(3) > button {
    width: 102px;
  }

  @media (max-width: 750px) {
    & > div,
    & > div > button {
      width: 100% !important;
    }
  }
`;
